<!--
 * @Descripttion:
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-02-22 14:37:43
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-10 17:38:26
-->
<template>
	<div>
		<el-dialog :title="`分配${zsName}`" width="400px" show-close :visible.sync="distribution" @close="resetFrom('disFrom')">
			<template slot="title">
				<p>
					<span class="yx-pingfang-Medium">分配{{ zsName }}</span>
					<span class="fz-14 yx-color-text-regular ml-20">{{ '(共' + total + '个商品)' }}</span>
				</p>
			</template>
			<div class="mb-8">待审核商品需先完成审核后分配招商运营，当前操作将自动过滤待审核状态的商品。</div>
			<el-form :model="disFrom" ref="disFrom" :rules="disRules">
				<el-form-item :label="zsName" label-width="80" prop="user_id">
					<zs-partner-select style="width: 240px" v-model="disFrom.user_id" :onlyOnState="true"></zs-partner-select>
				</el-form-item>
			</el-form>
			<div>
				<p class="yx-color-primary pointer fz-12" style="margin-left: 100px" @click="skipFun">找不到{{ zsName }}？建立新的{{ zsName }}账号</p>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button @click="distribution = false">取 消</el-button>
				<el-button type="primary" @click="checkRule">确 定</el-button>
			</div>
		</el-dialog>
		<collision-reminder ref="collisionReminder" @submit="sumbit" />
	</div>
</template>
<script>
import { productAllot, getNewShopUser } from '@/api/shopManage';
import { getProductConfig } from '@/api/settings.js';
import ZsPartnerSelect from '@/components/zsPartnerSelect';
import { zsRoleType } from '@/utils/dataMap';
import collisionReminder from '@/components/business/collisionReminder/collisionReminder.vue';
import { PLATFORM_DY } from '@/utils/dataMap';
export default {
	props: {
		platformId: {
			type: [Number, String],
			default: PLATFORM_DY.value,
		},
	},
	data() {
		return {
			distribution: false,
			imgUrl: 'https://cdn.chaoyongbushou.com/wx/20211108/1636372139805-c010edeb4a822302594d57f1bb6687c.png',
			disFrom: {
				user_id: '',
			},
			disRules: {
				user_id: [{ required: true, message: '请选择达人', target: 'blur' }],
			},
			operatingArr: [],
			params: {
				user_id: '',
				product_ids: '',
			},
			total: 1,
			list: [],
			productDuplicateAloneState: false,
			getNewShopUserState: 0,
		};
	},
	computed: {
		zsName() {
			return zsRoleType.name;
		},
	},
	methods: {
		async disInit(row) {
			this.params = {
				user_id: '',
				product_ids: '',
			};
			if (Array.isArray(row)) {
				if (!row.length) {
					this.$message.warning('请选择商品');
					return;
				}
				this.list = row;
				this.params.product_ids = row.map(item => item.product_id).join(',');
				this.total = row.length;
			} else {
				this.list = [row];
				this.params.product_ids = row.product_id;
				this.total = 1;
			}
			this.distribution = true;
			this.getConfig();
		},
		async getConfig() {
			const { data, code } = await getProductConfig({ platformId: this.platformId });
			if (code === 0) {
				this.productDuplicateAloneState = data.productDuplicateAlone;
			}
		},

		// 判断选择的商品是否有跟进人
		async formatFollow() {
			const { code, data } = await getNewShopUser({
				shopUserList: this.list.map(val => {
					return {
						shopId: val.shop_id,
						userId: this.disFrom.user_id,
					};
				}),
				platformId: this.platformId,
			});
			if (code === 0) {
				return data.canAllocate;
			}
		},
		// 判断如果是快手平台或者后端如果未开启跟进配置或者已经开启了但是选中的商品的跟进人是一样的 走之前的流程
		async checkRule() {
			this.$refs.disFrom.validate(async valid => {
				if (valid) {
					this.getNewShopUserState = (await this.formatFollow()) || 0;
					if (!this.productDuplicateAloneState) {
						this.Confirm();
						return;
					}
					if (this.productDuplicateAloneState && this.getNewShopUserState) {
						this.Confirm();
						return;
					}
					await this.$refs.collisionReminder.show(this.list, this.disFrom.user_id);
				}
			});
		},
		sumbit(obj) {
			this.params.product_ids = obj.product_ids;
			this.params.shopDuplicateType = obj.radioValue;
			this.Confirm();
		},
		async Confirm() {
			this.params.user_id = this.disFrom.user_id;
			this.params.platform_id = this.platformId;
			const { code } = await productAllot(this.params);
			if (code == 0) {
				this.$message.success('分配成功');
				this.$emit('refreshList');
				this.distribution = false;
				this.productDuplicateAloneState && !this.getNewShopUserState && this.$refs.collisionReminder.handleClose();
			}
		},
		skipFun() {
			this.$router.push({
				path: '/teamManage/subAccount',
			});
		},
		resetFrom(from) {
			this.$refs[from].resetFields();
		},
	},
	components: {
		ZsPartnerSelect,
		collisionReminder,
	},
};
</script>
<style lang="less" scoped>
/deep/ .el-select--small {
	width: 100%;
}
.right {
	text-align: right;
}
</style>
